import path from 'path';

export const tailwindConfig = {
  content: [
    // 当前执行目录是具体项目(apps/*)，用 cwd 定位项目自身和共享组件
    path.resolve(process.cwd(), './src/**/*.{ts,tsx,js,jsx,less,css}'),
    path.resolve(process.cwd(), '../../packages/*/src/**/*.{ts,tsx,js,jsx}'),
  ],
  theme: {
    extend: {},
  },
  plugins: [],
  corePlugins: { preflight: false },
}

